import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import CargomaticCard from 'components/v2/card';
import { isProd } from 'helpers/helper_functions';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
import SessionStore from '../../../stores/SessionStore';
import StripeAccountsStore from '../../../stores/StripeAccountsStore';
import CustomersAPIUtils from '../../../utils/CustomersAPIUtils';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';
import Alert from '../../ui/Alert';
import Badge from '../../v2/Badge';
import CheckedIndicator from '../../v2/CheckedIndicator';
import Sidebar from './Sidebar';
import Container from '../../v2/container';
class CarrierDocuments extends Component {
    constructor(props) {
        super(props);
        this.setRmisStatus = (status) => {
            if (status.CertificationStatus &&
                status.CertificationStatus.IsCertified === 'True') {
                this.setState({ documentsValid: true, loading: false });
            }
            if (status.CertificationStatus &&
                status.CertificationStatus.IsCertified === 'False') {
                this.setState({ documentsValid: false, loading: false });
            }
            if (status.Header.Result === 'ERROR') {
                this.setState({ apiError: true, loading: false });
                if (status.Header.Errors && status.Header.Errors.Error.length) {
                    const apiErrorText = status.Header.Errors.Error[0];
                    this.setState({ apiErrorText });
                }
            }
        };
        this.handleReceiveStripeInfo = () => {
            const accountInfo = StripeAccountsStore.getAccountInfo();
            if (!accountInfo)
                return;
            const bankAccount = (accountInfo.external_accounts || [])[0] || {
                id: null,
                bank_name: '',
                last4: '',
            };
            this.setState({
                bankAccount,
            });
        };
        this.handleStoreChange = () => {
            this.populateCarrierState();
        };
        this.renderBankingInformation = () => {
            var _a, _b;
            const verified = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.carrier) === null || _b === void 0 ? void 0 : _b.bank_verified;
            const { t } = this.props;
            return (React.createElement("div", { className: "" },
                React.createElement("div", { className: "flex flex-wrap justify-between" },
                    React.createElement("div", { className: "flex items-center mb-4 space-x-2" },
                        React.createElement("h3", { className: "my-0" }, t('BANK_INFORMATION')),
                        React.createElement(Badge, { color: verified ? 'brand' : 'yellow' }, verified ? t('VERIFIED') : t('PENDING'))))));
        };
        this.state = {
            authorized: false,
            documentsValid: false,
            loading: true,
            carrier: {},
            apiError: false,
            apiErrorText: null,
            bankAccount: {},
        };
    }
    componentDidMount() {
        const carrier = SessionStore.getUser();
        this.setState({ carrier });
        if (carrier.dot_number && isProd()) {
            CustomersAPIUtils.getCarrierRmisDocuments(carrier.dot_number, this.setRmisStatus);
        }
        SessionStore.addChangeListener(this.handleStoreChange);
        StripeAccountsStore.addChangeListener(this.handleReceiveStripeInfo);
        this.populateCarrierState();
        this.getCustomer();
    }
    componentWillUnmount() {
        SessionStore.removeChangeListener(this.handleStoreChange);
        StripeAccountsStore.addChangeListener(this.handleReceiveStripeInfo);
    }
    getCustomer() {
        const user = SessionStore.getUser();
        if (user) {
            CustomersActionCreators.getCustomer(user._id, false);
            CustomersActionCreators.getBankAccounts(user._id);
        }
    }
    populateCarrierState() {
        const carrier = SessionStore.getUser();
        if (!carrier) {
            return;
        }
        const { authorized } = carrier;
        this.setState({
            authorized,
            carrier,
        });
    }
    hasBankAccount() {
        const { id } = this.state.bankAccount;
        return id && id.length > 0;
    }
    renderPayoutValidation() {
        const completed = this.hasBankAccount();
        const { t } = this.props;
        const action = completed ? 'update' : 'add';
        const text = t('GO_TO_BILLING_AND_ACTION_YOUR_BANK', { action });
        return (React.createElement("div", { className: "" },
            React.createElement("div", { className: "flex flex-wrap justify-between" },
                React.createElement("div", { className: "flex items-center mb-4 space-x-2" },
                    React.createElement("h3", { className: "my-0" }, t('PAYOUT_VERIFICATION')),
                    React.createElement(Badge, { color: completed ? 'brand' : 'red' }, completed ? t('COMPLETED') : t('INCOMPLETE'))),
                React.createElement(LinkContainer, { className: "mt-2 mb-4 text-blue-700 cursor-pointer hover:text-blue-600 hover:underline", to: "/billing" },
                    React.createElement("div", null,
                        React.createElement("span", null, text),
                        React.createElement("span", { className: "ml-1" }, "\u2192")))),
            React.createElement("p", { className: "flex items-center space-x-2" },
                React.createElement("span", null, t('BANK_ON_FILE')),
                React.createElement("span", null,
                    React.createElement(CheckedIndicator, { checked: completed })))));
    }
    renderLoadingIndicator() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement("span", null, t('WAITING_FOR_RMIS_STATUS'))));
    }
    renderRMISIndicator() {
        const { t } = this.props;
        if (this.state.loading) {
            return this.renderLoadingIndicator();
        }
        if (this.state.apiError) {
            return this.renderRMISError();
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "flex flex-wrap justify-between" },
                React.createElement("div", { className: "flex items-center space-x-2" },
                    React.createElement("h3", { className: "my-0" }, t('RMIS_DOCUMENT_STATUS')),
                    this.state.documentsValid ? (React.createElement(Badge, { color: "brand" }, t('VALID'))) : (React.createElement(Badge, { color: "red" }, t('INVALID')))),
                React.createElement("a", { className: "text-blue-700 hover:text-blue-600", href: CARRIER_RMIS_LINK, target: "_blank", rel: "noopener noreferrer" },
                    React.createElement("span", { className: "mr-1" }, t('VIEW_DOCUMENTS_IN_RMIS')),
                    React.createElement("span", null, "\u2192"))),
            !this.state.documentsValid && (React.createElement(Alert, { type: "error", className: "mt-4" }, t('INVALID_DOCUMENT_FOUND_TIP')))));
    }
    // Carrier Does not have a DOT number attached to profile...
    renderDotMissingError() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(Alert, { title: t('ERROR_MISSING_DOT_NUMBER'), type: "error" },
                React.createElement("p", null, t('DOT_NUMBER_IS_REQUIRED_FOR_CARRIER_AUTHORIZATION')),
                React.createElement("p", null, t('DOT_NUMBER_IS_REQUIRED_FOR_CARRIER_AUTHORIZATION_TIP')),
                React.createElement("div", { className: "mt-4 actions" },
                    React.createElement(LinkContainer, { to: "/carrier-center", className: "font-medium cursor-pointer hover:text-red-600 hover:underline" },
                        React.createElement("div", null,
                            React.createElement("span", null, t('UPDATE_CARRIER_PROFILE')),
                            React.createElement("span", { className: "ml-1" }, "\u2192")))))));
    }
    renderRMISError() {
        const { t } = this.props;
        return (React.createElement("div", null,
            React.createElement(Alert, { title: t('RMIS_API_ERROR') },
                this.state.apiErrorText && React.createElement("p", null, this.state.apiErrorText),
                React.createElement("p", null,
                    t('DOT_NUMBER_CHECK_TIP'),
                    React.createElement(LinkContainer, { to: "/carrier-center" },
                        React.createElement("div", null,
                            React.createElement("span", null, t('UPDATE_CARRIER_PROFILE')),
                            React.createElement("span", { className: "ml-1" }, "\u2192")))))));
    }
    // Carrier has not been authorized
    renderCarrierInfo() {
        let selectedMarkets = 'None';
        const { carrier } = this.state;
        const { t } = this.props;
        const markets = carrier.markets || [];
        if (markets.length) {
            selectedMarkets = markets.map((m) => m.name).join(', ');
        }
        return (React.createElement("div", null,
            React.createElement("div", { className: "grid grid-cols-1 gap-x-4 sm:grid-cols-2" },
                React.createElement("div", { className: "sm:col-span-1 space-y-2" },
                    React.createElement("h4", { className: "my-0 text-sm font-medium text-gray-500 lg:mb-0" }, t('CURRENT_AUTHORIZATION_STATUS')),
                    React.createElement(Badge, { color: this.state.authorized ? 'brand' : 'red' }, this.state.authorized
                        ? titleize(t('AUTHORIZED'))
                        : titleize(t('UNAUTHORIZED')))),
                React.createElement("div", { className: "sm:col-span-1 space-y-2" },
                    React.createElement("h4", { className: "my-0 mt-4 text-sm font-medium text-gray-500 sm:mt-0" }, t('SELECTED_MARKETS')),
                    React.createElement("span", null, selectedMarkets))),
            !this.state.authorized && (React.createElement("div", { className: "mt-4" },
                React.createElement(Alert, { className: "my-4", type: "warning", title: "Almost There..." },
                    React.createElement("p", { className: "mb-1" }, t('NEED_FEW_DOCUMENTS_TO_ACCEPT_SHIPMENTS')),
                    React.createElement("p", { className: "mb-1" }, t('CLICK_BUTTON_BELOW_TO_UPDATE_DOCUMENTS_IN_RMIS')),
                    React.createElement("p", { className: "mb-1" }, t('IF_ALREADY_UPLOADED_DOCUMENTS_IN_RMIS_CHECK_STATUS_AGAIN_IN_24_HRS')),
                    React.createElement("div", { className: "actions" },
                        React.createElement("a", { className: "mt-4 font-medium text-yellow-700 hover:text-yellow-600 whitespace-nowrap", href: CARRIER_RMIS_LINK, target: "_blank", rel: "noopener noreferrer" },
                            React.createElement("span", { className: "mr-1" }, t('GO_TO_RMIS')),
                            React.createElement("span", { className: "text-yellow-700", "aria-hidden": "true" }, "\u2192"))))))));
    }
    render() {
        const hasDOT = this.state.carrier.dot_number && this.state.carrier.dot_number.length;
        const { t } = this.props;
        return (React.createElement(Container, { className: "documents" },
            React.createElement("div", { className: "lg:grid lg:grid-cols-12 lg:gap-6 mt-10" },
                React.createElement("div", { className: "lg:col-span-3" },
                    React.createElement(Sidebar, { activePage: "documents" })),
                React.createElement("div", { className: "lg:col-span-6" },
                    React.createElement(CargomaticCard, { header: () => React.createElement("h3", { className: "my-0" }, t('MY_DOCUMENTS')) },
                        this.renderCarrierInfo(),
                        React.createElement("hr", null),
                        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                            hasDOT
                                ? this.renderRMISIndicator()
                                : this.renderDotMissingError(),
                            React.createElement("hr", null),
                            this.renderPayoutValidation()),
                        React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.US] }, this.renderBankingInformation()))))));
    }
}
export default withTranslation()(CarrierDocuments);
